import { hasValue } from '../../modules/app-global/scripts/utils/object/object';

export function createKey(index, anything) {
    return index.toString() + '_' + (hasValue(anything) ? anything.toString() : '');
}



// WEBPACK FOOTER //
// ./collection-institutional-portal/src/common/react-helpers/key-creator.js